export const defaultContainerConfiguration = {
    boxShadow: 'none',
    borderRadius: '0',
    contentAreaBorder: undefined,
    tableBorder: undefined,
    popUpsAndLinksBorder: undefined,
    popUpsAndLinksBoxShadow: undefined,
    tabSeparatorBackground: undefined,
    border: undefined,
    boxShadow2: undefined,
};
